export default "__VITE_ASSET__BsHBpOj6__"